/*
 * @Author: chj
 * @Date: 2024-10-10 11:13:47
 * @LastEditors: chj
 * @LastEditTime: 2024-11-06 16:24:13
 * @Description: 请填写简介
 */
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import 'ant-design-vue/dist/antd.less'
import 'aos/dist/aos.css';

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import bem from '@/plugins/bem'

import { register } from 'swiper/element/bundle'

Vue.config.productionTip = false

Vue.use(bem)

register()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

